import { render, staticRenderFns } from "./EditorVideo.vue?vue&type=template&id=1f1cfbb6&"
import script from "./EditorVideo.vue?vue&type=script&lang=js&"
export * from "./EditorVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports